// usePermissions.js
import { useState, useEffect } from "react";

const usePermissions = () => {
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const rights = JSON.parse(localStorage.getItem("rights"));
    const cleanedData = rights ? JSON.parse(rights.replace(/\\/g, "")) : [];
    if (!cleanedData) return;

    const perms = {};
    cleanedData.forEach((role) => {
      if (!role.children || !Array.isArray(role.children)) return;

      role.children.forEach((child) => {
        if (!child.permissions || typeof child.permissions !== "object") return;

        const permKeyBase = child.title.replace(/\s+/g, ""); // Remove spaces
        const permKeys = Object.keys(child.permissions);

        permKeys.forEach((perm) => {
          const permissionName = `${permKeyBase}.${perm}`; // Key name: "ReportManagement.EditPermission"
          perms[permissionName] = child.permissions[perm] === 1; // Set true if 1, false if 0
        });
      });
    });
    setPermissions(perms);
  }, []);

  const hasPermission = (entity, action) => {
    if (action === "hasNoPermission") return true;
    if (entity && action) {
      const permKey = `${entity.replace(/\s+/g, "")}.${action}`;
      return permissions[permKey] || false;
    }
    return false;
  };

  return { permissions, hasPermission };
};

export default usePermissions;
